import { combineReducers } from "redux";

import search from "./search";

const reducers = combineReducers({
  search,
});

export default reducers;
